import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// The "ResizeObserver loop completed with undelivered notifications" browser
// notice is benign, but the CRA dev-server overlay treats it as a fatal error
// and covers the page. Hide the overlay for this specific message (dev only).
if (process.env.NODE_ENV === 'development') {
  const isResizeObserverError = (message) =>
    typeof message === 'string' && message.includes('ResizeObserver loop');

  window.addEventListener('error', (event) => {
    if (!isResizeObserverError(event.message)) return;
    event.stopImmediatePropagation();
    const hideOverlay = () => {
      const overlay = document.getElementById('webpack-dev-server-client-overlay');
      if (overlay) overlay.style.display = 'none';
    };
    hideOverlay();
    setTimeout(hideOverlay, 0);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
